import { useEffect } from 'react';
import deviceMetadataManager from '../utils/deviceMetadata';

export const useDeviceMetadata = () => {
  useEffect(() => {
    // Initialize on component mount
    deviceMetadataManager.initialize();
  }, []);

  const updateUserContext = () => {
    deviceMetadataManager.updateUserContext();
  };

  return { updateUserContext };
};